const cn = {
    common:{
        understandDeeply:"深入了解",
        installationGuide:"安装指导",
        downloadMaterials:"资料下载",
        helpAndSupport:"帮助支持",
        followUs:"关注我们",
        downloadVedio:"下载视频",
        downloading:"下载中...",
        gallery:"图集",
        customer:"我是客服康康",
        customerContent:"有问题可以咨询我",
        product:"海康汽车消费类产品",
        search:"搜索",
        searchPlaceholder:"请输入搜索关键词",
        historySearch:"历史搜索",
        loading:"加载中...",
        cancel:"取消",
        noData:"暂无数据",
        confirmDelete:"确认删除全部历史记录",
        downloadFail:"下载失败",
        confirmDownload:"确定下载",
        closeMessage:"轻触屏幕即可关闭指引",
        vedio:"视频",
        picture:"图片"
    }
}
export default cn;


// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js